export default[
    {
        name: 'InventionPatent',
        path: 'InventionPatent',
        component: () => import('@/pages/knowledge/InventionPatent'),
        meta: { title: '发明专利维权' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
           
            }
        }
    },
    {
        name: 'UtilityPatent',
        path: 'UtilityPatent',
        component: () => import('@/pages/knowledge/UtilityPatent'),
        meta: { title: '实用新型专利维权' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
           
            }
        }
    },
    {
        name: 'DesignPatent',
        path: 'DesignPatent',
        component: () => import('@/pages/knowledge/DesignPatent'),
        meta: { title: '外观设计专利维权' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
           
            }
        }
    },
    {
        name: 'GoodsTrademark',
        path: 'GoodsTrademark',
        component: () => import('@/pages/knowledge/GoodsTrademark'),
        meta: { title: '商标商品维权' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
           
            }
        }
    },
    {
        name: 'ServiceMark',
        path: 'ServiceMark',
        component: () => import('@/pages/knowledge/ServiceMark'),
        meta: { title: '服务商标维权' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
           
            }
        }
    },
    {
        name: 'CopyrightRights',
        path: 'CopyrightRights',
        component: () => import('@/pages/knowledge/CopyrightRights'),
        meta: { title: '著作权维权' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
           
            }
        }
    }
]